import { useEffect, useMemo } from 'react';
import { AssessmentsModel, seedAssessments } from '../models/AssessmentsModel';

/**
 * The Assessments model (PRD-1703) beside the Library model it takes its
 * scenarios from. It lives as long as that model does, so it's rebuilt with it
 * when the user or the active organisation changes, and a replaced model stops
 * its timer rather than ticking on unseen.
 */
export const useAssessmentsModel = (libraryModel) => {
  const model = useMemo(() => new AssessmentsModel(libraryModel, seedAssessments()), [libraryModel]);
  useEffect(() => () => model.stop(), [model]);
  return model;
};
